import { z } from 'my-zod'
import { enumOptionsToObject } from '../../internal'
import { emailEvent, emailModel } from './email-model'
import { emailSystemView } from './email-system-view'

const EmailCategoryOptions = [
  // SendPreRideEmail category used for "reservation-reminder" (now is "old-reservation-reminder")
  'SendPreRideEmail',
  'SendPreRideEmail2',
  'SendWaiverInvitationEmail',
  'SendOutfitterAddressUpdateNotificationEmail',
  'SendServiceEnablementEmail',
  'SendCustomerVehicleCheckoutEmail',
  'SendCustomerSurveyEmail',
  'SendUniversityPolarisAccessRequestEmail',
  'CreditShareRequest',
  'SendReservationNotificationEmail',
  'send-waiver-expiration-notification-use-case',
  'SendInternalCancellationEmail',
  // SendReservationConfirmationNotification category used for "reservation-confirmation" (now is "old-reservation-confirmation")
  'SendReservationConfirmationNotification',
  'SendReservationConfirmationNotification2',
  'SendCertificationExpirationUseCase',
  'SendChangeBankAccountNotificationMail',
  'SendRemoveBankAccountNotificationMail',
  'SendOutfitterOwnerAddedEmail',
  'SendRentalDocumentsBundleEmail',
  'SendSelectWelcomeNotification',
  'SendEmailWithCsvAttachment',
  'send-signed-vehicle-order-notification-use-case',
  'SendOutfitterDailyReservationReport',
  'SendGitHubBugReportEmail',
  'SetupMemberSubscriptionUseCase',
  'fail-payment-provider',
  'SendAdHocFormSubmissionNotificationEmail',
  'SendUnfinishedTasksNotificationEmail',
  'SendDisputeNotificationEmail',
  'SendReservationCreateConfirmation',
  'SendUserDeletionRequest',
  'SendAbandonedCustomerOrderCartEmailForCustomer',
  'SendAbandonedCustomerOrderCartEmailForOutfitterUser'
] as const

const EmailCategories = enumOptionsToObject(EmailCategoryOptions)

export const EmailSchemas = {
  EmailCategories,
  emailModel,
  emailEvent,
  emailSystemView
}

export declare namespace EmailSchemas {
  export type emailModel = z.infer<typeof emailModel>
  export type emailEvent = z.infer<typeof emailEvent>
  export type emailSystemView = z.infer<typeof emailSystemView>
}
